import { useQuery } from "@tanstack/react-query";
import { getProjectRecommendations } from "@/app/actions/project/action";
import { ProjectCallsRecommendationKind } from "@/app/types/call/CallAnalysis";
import { QueryKey } from "@/app/vars/QueryKeys";

export function useFetchProjectRecommendations(
  projectId?: number,
  kind?: ProjectCallsRecommendationKind,
) {
  return useQuery({
    queryKey: [QueryKey.PROJECT_RECOMMENDATIONS, projectId, kind],
    queryFn: () => {
      if (!projectId) return null;
      return getProjectRecommendations(projectId, kind);
    },
    enabled: !!projectId,
    staleTime: Infinity,
  });
}
